// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function call(f) {
  Belt_Option.map(f, (function (f) {
          return f();
        }));
}

function callWith(f, x) {
  Belt_Option.map(f, (function (f) {
          return f(x);
        }));
}

function wrapApiWithStoreEvents(api, dispatch, onActivityCompleted, onActivityPaused, onActivityReachedEnd, onActivityReady, onActivityResumed, onActivityStarted, onExit, onFailed, onQuestionFailed, onQuestionPassed, onQuestionStarted, onBatchQuestionsAnswered, onPreloaderReady, param) {
  return api((function (param) {
                dispatch("ActivityCompleted");
                call(onActivityCompleted);
              }), (function (param) {
                dispatch("ActivityPaused");
                call(onActivityPaused);
              }), (function (param) {
                dispatch("ActivityReachedEnd");
                call(onActivityReachedEnd);
              }), (function (param) {
                dispatch("ActivityReady");
                call(onActivityReady);
              }), (function (param) {
                dispatch("ActivityResumed");
                call(onActivityResumed);
              }), (function (param) {
                dispatch("ActivityStarted");
                call(onActivityStarted);
              }), (function (param) {
                dispatch("Exit");
                call(onExit);
              }), (function (__x) {
                callWith(onFailed, __x);
              }), (function (result) {
                if (typeof result === "object") {
                  if (result.TAG === "Orig") {
                    dispatch({
                          TAG: "QuestionFailed",
                          question: result._0.question,
                          responsesCorrect: undefined,
                          responsesComplete: undefined
                        });
                  } else {
                    dispatch({
                          TAG: "QuestionFailed",
                          question: result._0.question,
                          responsesCorrect: undefined,
                          responsesComplete: undefined
                        });
                  }
                }
                callWith(onQuestionFailed, result);
              }), (function (result) {
                if (typeof result === "object") {
                  if (result.TAG === "Orig") {
                    dispatch({
                          TAG: "QuestionPassed",
                          question: result._0.question,
                          responsesCorrect: undefined,
                          responsesComplete: undefined
                        });
                  } else {
                    dispatch({
                          TAG: "QuestionPassed",
                          question: result._0.question,
                          responsesCorrect: undefined,
                          responsesComplete: undefined
                        });
                  }
                }
                callWith(onQuestionPassed, result);
              }), (function (q) {
                dispatch("QuestionStarted");
                callWith(onQuestionStarted, q);
              }), (function (questions) {
                if (typeof questions === "object") {
                  dispatch({
                        TAG: "BulkQuestions",
                        _0: Belt_Array.map(questions._0, (function (param) {
                                return param.correct;
                              }))
                      });
                }
                callWith(onBatchQuestionsAnswered, questions);
              }), (function (background) {
                dispatch({
                      TAG: "PreloaderReady",
                      _0: background
                    });
                callWith(onPreloaderReady, background);
              }));
}

function defaultCb(param) {
  
}

var defaultDispatchables = {
  onActivityCompleted: defaultCb,
  onActivityPaused: defaultCb,
  onActivityReachedEnd: defaultCb,
  onActivityReady: defaultCb,
  onActivityResumed: defaultCb,
  onActivityStarted: defaultCb,
  onExit: defaultCb,
  onFailed: defaultCb,
  onQuestionFailed: defaultCb,
  onQuestionPassed: defaultCb,
  onQuestionStarted: defaultCb,
  onBatchQuestionsAnswered: defaultCb,
  onPreloaderReady: defaultCb
};

var context = React.createContext(defaultDispatchables);

function makeProps(value, children, param) {
  return {
          value: value,
          children: children
        };
}

var make = context.Provider;

function use() {
  return React.useContext(context);
}

var Context = {
  context: context,
  makeProps: makeProps,
  make: make,
  use: use
};

function FlipperCobraCallbacks$Provider(props) {
  return React.createElement(make, {
              value: props.dispachables,
              children: props.children
            });
}

var Provider = {
  make: FlipperCobraCallbacks$Provider
};

export {
  call ,
  callWith ,
  wrapApiWithStoreEvents ,
  defaultCb ,
  defaultDispatchables ,
  Context ,
  Provider ,
}
/* context Not a pure module */
